// extracted by mini-css-extract-plugin
export default {"wrapper":"Video_wrapper__eERJD","inner":"Video_inner__5WLb1","views":"Video_views__OfgOq","date":"Video_date__Q4glP","mainInfo":"Video_mainInfo__JIe-N"};